import { render, staticRenderFns } from "./PosOrderList.vue?vue&type=template&id=0c80c166&scoped=true&"
import script from "./PosOrderList.vue?vue&type=script&lang=js&"
export * from "./PosOrderList.vue?vue&type=script&lang=js&"
import style0 from "./PosOrderList.vue?vue&type=style&index=0&id=0c80c166&scoped=true&lang=css&"
import style1 from "./PosOrderList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c80c166",
  null
  
)

export default component.exports